// src/stone/icons/Heart24.tsx
import { jsx } from "react/jsx-runtime";
var Heart24 = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentcolor",
        d: "M19.813 36.783a1 1 0 0 1-.71-.3l-14.71-14.73a10.17 10.17 0 1 1 14.36-14.36l1.06 1 1.06-1a10.15 10.15 0 0 1 14.38 0 10 10 0 0 1 2.2 3.3 10.18 10.18 0 0 1-2.2 11.08l-14.73 14.71a1 1 0 0 1-.71.3m-8.25-30.39a8.17 8.17 0 0 0-5.78 14l14 14 14-14a8.4 8.4 0 0 0 1.77-2.66c.41-.99.62-2.05.62-3.12a8.2 8.2 0 0 0-.56-3.22 8.4 8.4 0 0 0-1.77-2.65 8.18 8.18 0 0 0-11.56 0l-1.76 1.81a1 1 0 0 1-1.42 0l-1.71-1.77a8.15 8.15 0 0 0-5.83-2.39"
      }
    )
  }
);
var Heart24_default = Heart24;

export {
  Heart24_default
};
